var companyMsg = {
    name:'深圳市金矿网络科技有限公司',
    address:'深圳市宝安区金宝科创中心1015',
    phone:'4006-352-107',
    postcode:'518101',
    email:'support@gminsz.com',
    wxGirl:'7动-盆底肌锻炼助手',
    wxBoy:'盆底肌训练助手',
    weibo:'7动盆底肌训练助手',
    hezuo:'marketing@gminsz.com'
}
export {
    companyMsg
}


// WEBPACK FOOTER //
// ./src/components/data.js